import type { TextBlock } from '@schibsted/frapi-schema';
import type {
  AdComponent,
  ImageComponent,
  ListBlock,
  SubheadingComponent,
  TextComponent,
} from './types.js';

import { isObject } from '../../utils/type-guards.js';

export const isComponentType = (component: unknown, type: string) =>
  isObject(component) &&
  'type' in component &&
  typeof component.type === 'string' &&
  component.type === type;

export const isTextComponent = (
  component: unknown,
): component is TextComponent => isComponentType(component, 'text');

export const isSubheadingComponent = (
  component: unknown,
): component is SubheadingComponent => isComponentType(component, 'subheading');

export const isImageComponent = (
  component: unknown,
): component is ImageComponent => isComponentType(component, 'image');

export const isAdComponent = (component: unknown): component is AdComponent =>
  isComponentType(component, 'ad');

export const isListBlock = (
  richTextBlock: unknown,
): richTextBlock is ListBlock =>
  isObject(richTextBlock) &&
  'items' in richTextBlock &&
  Array.isArray(richTextBlock.items);

export const isTextBlock = (
  richTextBlock: unknown,
): richTextBlock is TextBlock =>
  isObject(richTextBlock) &&
  'text' in richTextBlock &&
  isObject(richTextBlock.text);
